import React from 'react';
import { formatCoverage } from '../dateUtils';

/*
 * GapAlert
 * --------
 * Prominent red callout shown when a user's address or employment timeline
 * has one or more uncovered gaps inside the required 3-year window. Used at
 * both the top and the bottom of the relevant step so it's hard to miss.
 *
 * Props:
 *   - kind: "address" | "employment" - drives label copy
 *   - gaps: [{ from, to, months }]
 */
class GapAlert extends React.Component {
  render() {
    const { kind, gaps } = this.props;
    if (!Array.isArray(gaps) || gaps.length === 0) return null;

    const noun = kind === 'employment' ? 'employment' : 'address';
    const action =
      kind === 'employment'
        ? 'Please add a previous role that covers this period.'
        : 'Please add a previous address that covers this period.';

    return (
      <div
        className="rounded-2xl"
        style={{
          backgroundColor: '#FEE2E2',
          borderLeft: '4px solid #DC2626',
          padding: '14px 16px',
        }}
      >
        <div className="flex items-start gap-3">
          <span
            className="inline-flex items-center justify-center h-7 w-7 rounded-full flex-shrink-0"
            style={{ backgroundColor: '#DC2626', color: '#FFFFFF' }}
            aria-hidden="true"
          >
            <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M8.3 2.7a2 2 0 013.4 0l6.5 11A2 2 0 0116.5 17h-13a2 2 0 01-1.7-3.3l6.5-11zM10 7a1 1 0 011 1v3a1 1 0 11-2 0V8a1 1 0 011-1zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clipRule="evenodd"
              />
            </svg>
          </span>
          <div className="flex-1 min-w-0">
            <p
              className="text-sm sm:text-base font-bold"
              style={{ color: '#7F1D1D' }}
            >
              Gap in your {noun} history
            </p>
            <ul className="mt-2 space-y-1.5 text-sm" style={{ color: '#7F1D1D' }}>
              {gaps.map((g, i) => (
                <li key={i}>
                  There is a <strong>{formatCoverage(g.months)}</strong> gap
                  between <strong>{g.from}</strong> and <strong>{g.to}</strong>.{' '}
                  {action}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default GapAlert;
